<script lang="ts">
	import { onMount } from 'svelte';
	import { createEventDispatcher } from 'svelte';
	import type { TurnstileInstance } from '$lib/types/window';

	const dispatch = createEventDispatcher();
	let turnstileElement: HTMLElement;
	let turnstile: TurnstileInstance;

	export let theme: 'light' | 'dark' = 'dark';
	export let sitekey = '0x4AAAAAAA0k-v1aGN7meJAf';

	onMount(() => {
		// Load Turnstile script
		const script = document.createElement('script');
		script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
		script.async = true;
		script.defer = true;
		document.head.appendChild(script);

		script.onload = () => {
			turnstile = window.turnstile;
			turnstile.render(turnstileElement, {
				sitekey,
				theme,
				callback: function (token: string) {
					dispatch('success', { token });
				},
				'expired-callback': function () {
					dispatch('expired');
				},
				'error-callback': function () {
					dispatch('error');
				}
			});
		};

		return () => {
			if (turnstileElement && turnstile) {
				turnstile.remove(turnstileElement);
			}
		};
	});

	export function reset() {
		if (turnstile && turnstileElement) {
			turnstile.reset(turnstileElement);
		}
	}
</script>

<div id="turnstile-widget" class="mb-4" bind:this={turnstileElement}></div>
